import React, { useCallback, useState } from 'react'
import { object, bool, func } from 'prop-types'
import { Input, Switch, Button, Form, Collapse, Select } from 'antd'
import { ApiOutlined, DeleteOutlined } from '@ant-design/icons'

import { Widget, useUpdate, useValidation } from './base/widget'
import { CommonFields } from './base/widgetCommonFields'
import { FormItem, styleIconValidation } from './base/styles'
import { ThinDivider } from './base/styles'

export const ApiWidget = React.memo((props) => {
	const { data } = props

	const update = useUpdate(props)
	const [valid, setValid] = useValidation(props)
	// const [form] = Form.useForm()
	const [typedProperties, setTypedProperties] = useState(
		data.variable?.typed_properties || []
	)

	// Atualiza o estado do formulário com os valores do banco
	// useEffect(() => {
	// 	form.setFieldsValue({ images: typedProperties })
	// }, [typedProperties, form])

	const updateVariable = useCallback(
		(key, value) => {
			update({ variable: { ...data.variable, [key]: value } })
		},
		[data, update]
	)

	const addNewTypedProperty = useCallback(() => {
		const newProperty = {
			name: '',
			type: 'image',
			options: { source_type: '', width: 0 },
		}
		const updatedProperties = [...typedProperties, newProperty]
		setTypedProperties(updatedProperties)
		update({
			variable: { ...data.variable, typed_properties: updatedProperties },
		})
	}, [typedProperties, update, data.variable])

	const updateTypedProperties = useCallback(
		(index, key, value) => {
			const updatedProperties = typedProperties.map((item, i) =>
				i === index
					? {
							...item,
							[key]: key === 'options' ? { ...item.options, ...value } : value,
						}
					: item
			)
			setTypedProperties(updatedProperties)
			update({
				variable: { ...data.variable, typed_properties: updatedProperties },
			})
		},
		[typedProperties, update, data.variable]
	)

	return (
		<Widget
			{...props}
			type={'Api'}
			icon={<Icon $error={!valid} />}
			onValidate={setValid}
			formItems={
				<>
					<CommonFields
						data={data}
						update={update}
						extraFields={
							<ExtraFieldList apiList={data.api_list} update={update} />
						}
					/>
					<FormItem label="Placeholder">
						<Input
							onBlur={(e) => update({ placeholder: e.target.value })}
							defaultValue={data.placeholder}
							autoComplete="off"
						/>
					</FormItem>
					<FormItem label="Endpoint">
						<Input
							onBlur={(e) => updateVariable('api_endpoint', e.target.value)}
							defaultValue={data?.variable?.api_endpoint}
							autoComplete="off"
						/>
					</FormItem>
					<ThinDivider orientation="left">Imagens</ThinDivider>
					<Form.List name="images" initialValue={typedProperties}>
						{(fields, { add, remove }) => (
							<>
								{fields.map((field, index) => (
									<div key={field.key} style={{ marginBottom: '8px' }}>
										<Collapse>
											<Collapse.Panel
												header={`Imagem ${index + 1}`}
												key={field.key}
												extra={
													<Button
														type="link"
														icon={<DeleteOutlined />}
														onClick={(e) => {
															e.stopPropagation()
															remove(field.name)
															const updatedProperties = typedProperties.filter(
																(_, i) => i !== index
															)
															setTypedProperties(updatedProperties)
															update({
																variable: {
																	...data.variable,
																	typed_properties: updatedProperties,
																},
															})
														}}
													/>
												}>
												<div style={{ paddingTop: '16px' }}>
													<FormItem label="Nome">
														<Input
															onBlur={(e) =>
																updateTypedProperties(
																	index,
																	'name',
																	e.target.value
																)
															}
															defaultValue={
																data?.variable?.typed_properties?.[index]
																	?.name || ''
															}
															autoComplete="off"
														/>
													</FormItem>
													<FormItem label="Fonte">
														<Select
															defaultValue={
																data?.variable?.typed_properties?.[index]
																	?.options?.source_type || ''
															}
															onChange={(value) =>
																updateTypedProperties(index, 'options', {
																	source_type: value,
																})
															}
															placeholder="Selecione a fonte">
															<Select.Option value="base64">
																Base64
															</Select.Option>
															<Select.Option value="url">URL</Select.Option>
														</Select>
													</FormItem>
													<FormItem label="Largura">
														<Input
															onBlur={(e) =>
																updateTypedProperties(index, 'options', {
																	width: e.target.value,
																})
															}
															defaultValue={
																data?.variable?.typed_properties?.[index]
																	?.options?.width || ''
															}
															autoComplete="off"
														/>
													</FormItem>
												</div>
											</Collapse.Panel>
										</Collapse>
									</div>
								))}
								<Form.Item>
									<Button
										type="primary"
										onClick={() => {
											add()
											addNewTypedProperty()
										}}
										style={{ width: '150px' }}
										block>
										Adicionar Imagem
									</Button>
								</Form.Item>
							</>
						)}
					</Form.List>
				</>
			}
		/>
	)
})

function ExtraFieldList({ api_list, update }) {
	return (
		<FormItem
			style={{ alignSelf: 'flex-end', marginRight: 48 }}
			label="Lista"
			$width={'fit-content'}
			$labelWidth={'66px'}
			$labelTop={'1px'}>
			<Switch
				defaultChecked={api_list}
				onChange={(e) =>
					update({
						api_list: e,
					})
				}
			/>
		</FormItem>
	)
}

const Icon = styleIconValidation(ApiOutlined)

ApiWidget.propTypes = {
	data: object,
}

ExtraFieldList.propTypes = {
	api_list: bool,
	update: func,
}
